export class PayPalIdAlreadyUsedError extends Error {
  constructor() {
    super(
      'PayPal SDK wants to use dom element with id "paypal" but it\'s already in use!',
    );
    this.name = 'PayPalIdAlreadyUsedError';
  }
}
